import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { AppService } from "src/app/core/services/app.service";
import { FocusPayMerchantTitles } from "src/app/shared/models/enums/focuspay-merchant-contact-type";
import { MerchantContact } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-merchant-contact-record",
	templateUrl: "./merchant-contact-record.component.html",
	styleUrls: ["../../../focuspay.style.scss"],
})
export class MerchantContactRecordComponent implements OnInit {
	@Input() contact: MerchantContact;
	@Input() contactIdx: number;
	@Input() readOnly: boolean;

	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() subSectionCompleteEmitter = new EventEmitter<any>();
	@Output() contactPocChangeEmitter = new EventEmitter<MerchantContact>();
	@Output() removeContactEmitter = new EventEmitter<number>();

	contactTitles: { label: string; value: string }[] = [];

	contactFirstNameControl: UntypedFormControl;
	contactLastNameControl: UntypedFormControl;
	contactTitleControl: UntypedFormControl;
	contactOwnershipPercentageControl: UntypedFormControl;
	contactDateOfBirthControl: UntypedFormControl;
	contactSocialSecurityNumberControl: UntypedFormControl;

	constructor(public app: AppService) {}

	ngOnInit(): void {
		for (const [k, v] of Object.entries(FocusPayMerchantTitles)) {
			this.contactTitles.push({
				label: k,
				value: v,
			});
		}

		this.contactFirstNameControl = new UntypedFormControl({ value: this.contact.firstName, disabled: this.readOnly }, [Validators.required]);
		this.contactLastNameControl = new UntypedFormControl({ value: this.contact.lastName, disabled: this.readOnly }, [Validators.required]);
		this.contactTitleControl = new UntypedFormControl({ value: this.contact.title, disabled: this.readOnly }, [Validators.required]);
		this.contactOwnershipPercentageControl = new UntypedFormControl({ value: this.contact.ownershipPercentage, disabled: this.readOnly }, [
			Validators.required,
			Validators.min(20),
			Validators.max(100),
		]);
		this.contactDateOfBirthControl = new UntypedFormControl({ value: this.contact.dateOfBirth, disabled: this.readOnly }, [Validators.required]);
		this.contactSocialSecurityNumberControl = new UntypedFormControl({ value: this.contact.socialSecurityNumber, disabled: this.readOnly }, [Validators.required]);
		this.inputAction();
	}

	contactPocChange() {
		this.contactPocChangeEmitter.emit(this.contact);
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.subSectionCompleteEmitter.emit({
			contactIndex: this.contactIdx,
			complete: false,
		});
		if (!this.contactFirstNameControl.value || this.contactFirstNameControl.errors) return;
		if (!this.contactLastNameControl.value || this.contactLastNameControl.errors) return;
		if (!this.contactTitleControl.value || this.contactTitleControl.errors) return;
		if (!this.contactOwnershipPercentageControl.value || this.contactOwnershipPercentageControl.errors) return;
		if (!this.contactDateOfBirthControl.value || this.contactDateOfBirthControl.errors) return;
		if (!this.contactSocialSecurityNumberControl.value || this.contactSocialSecurityNumberControl.errors) return;
		this.subSectionCompleteEmitter.emit({
			contactIndex: this.contactIdx,
			complete: true,
		});
	}
}
